import React, { memo, useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton';
import { useDebouncedCallback } from 'use-debounce/lib';
import DatePicker from 'react-datepicker';
import moment, { months } from 'moment';

import { Field } from 'formik';
import { convertDateFromUkToUs } from '../utils/utilityFunctions';


const DateField = ({
  fieldName,
  dateChangeHandler,
  rest,
  readOnly,
  saveForm,
}) => {

  const [isLoading, setIsLoading] = useState(false);

  const onChangeHandler = (date, form) => {
    const dateToSave = date ? moment(date).format("DD/MM/YYYY") : null;
    dateChangeHandler({
      fieldName,
      saveForm,
      setIsLoading,
      values: form.values,
      fieldValue: dateToSave,
      setFieldValue: form.setFieldValue,
      form,
      date,
    }) 
  }

  return (
    <Field name={fieldName}>
      {
        ({ field, form }) => {
          const selectedValue = (field.value && typeof field.value !== "object") ? new Date(convertDateFromUkToUs(field.value)) : null;
          return (
            <div className="relative flex items-center h-full">
              
              <DatePicker
                selected={selectedValue}
                onChange={(date) => onChangeHandler(date, form)}
                dateFormat="dd/MM/yyyy"
                className="pep-input"
                showYearDropdown
                dropdownMode="select"
                {...rest}
              /> 
                  
              {
                isLoading &&
                <div className="rounded-2xl px-3 absolute bg-white w-full h-full top-0 left-0 grid items-center">
                  <Skeleton count={1} />
                </div>
              }
            </div>
          )
        }
      }
    </Field>

  )
}

const isEqual = (prevState, nextState) => {
  if (prevState.value === nextState.value) {
    return true;
  } else {
    return false;
  }
}

// export default memo(DataDateField, isEqual);
export default DateField;
